import { writable } from '@dabble/data/stores/store';

export const showHistory = writable(false);
